import type { Step } from 'react-joyride';

// How long joyride waits for a step's target to appear in the DOM before
// showing that step's tooltip. The panel fetches its inquiries after mount, so
// wait generously to avoid the tour silently skipping a step whose element
// isn't ready yet.
const TARGET_WAIT_TIMEOUT_MS = 3_000;

/**
 * Tour steps for the unified inbox (`/inbox`), narrowing top-down: which side
 * of the conversation, then which status, then the inquiries themselves.
 *
 * Both of the first two targets are conditional. The role tabs render only for
 * a professional (`showRoleTabs`), and the status chips only on the Received
 * tab (`showStatusFilter`) — which is why `InboxTour` gates on the role tabs
 * existing. A client, who sees a bare list with neither control, gets no tour:
 * a single step over a list of rows teaches nothing.
 *
 * Copy is resolved from the `Tour.inbox.*` i18n namespace at render time —
 * these are keys, not hardcoded strings.
 */
export const inboxTourSteps: Step[] = [
  {
    target: '[data-tour="inbox-tabs"]',
    title: 'inbox.title.tabs',
    content: 'inbox.content.tabs',
    placement: 'right' as const,
    skipBeacon: true,
    targetWaitTimeout: TARGET_WAIT_TIMEOUT_MS,
  },
  {
    target: '[data-tour="inbox-status"]',
    title: 'inbox.title.status',
    content: 'inbox.content.status',
    placement: 'right' as const,
    skipBeacon: true,
    targetWaitTimeout: TARGET_WAIT_TIMEOUT_MS,
  },
  {
    target: '[data-tour="inbox-list"]',
    title: 'inbox.title.list',
    content: 'inbox.content.list',
    placement: 'right' as const,
    skipBeacon: true,
    targetWaitTimeout: TARGET_WAIT_TIMEOUT_MS,
  },
];
